module.exports = __webpack_public_path__ + "img/CRT_WF_Weapon-Sword-1.fbc4b810.png";